import React from 'react'
import Sidenav from './components/Sidenav'
import ProductGrid from './pages/Productgrip'

export default function Products() {
  return (
    <> 
    
    <div className="flex  ">
       <div className="">
       <Sidenav />
       </div>
        <div className="mt-16">
            <ProductGrid />
        </div>
    </div>
    </>
  )
}
